import { render } from "./tag-info.vue?vue&type=template&id=e2876dd2&scoped=true"
import script from "./tag-info.vue?vue&type=script&lang=js"
export * from "./tag-info.vue?vue&type=script&lang=js"

import "./tag-info.vue?vue&type=style&index=0&id=e2876dd2&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2876dd2"]])

export default __exports__